module.exports = __webpack_public_path__ + "img/bannerimg02.b50c4873.png";